import { render, staticRenderFns } from "./link-list.vue?vue&type=template&id=214bf6f8&"
import script from "./link-list.vue?vue&type=script&lang=js&"
export * from "./link-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports